import { FormControl, FormControlLabel } from '@mui/material';
import { isEmpty } from 'lodash';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { diff } from '../../../../../../../../services/timeService';
import { getDate } from '../../../../../../../../services/timeService/index';
import { dateTimeFormat, unitOfTime } from '../../../../../../../../services/timeService/types';
import CustomDatePicker from '../../../../../../../CustomDatePicker/index';
import { dateValidationError } from '../../../../../../../CustomDatePicker/types';
import CheckboxField from '../../../../../../../Inputs/CheckboxField';
import styles from '../index.module.scss';

const FallBlock = () => {
  const { register, watch, getValues, control } = useFormContext();
  const fallDate = getValues('fallDate');
  const isShowFallDate = !!fallDate && diff(fallDate, unitOfTime.year) < 1;
  const watchFall = watch('fall', isShowFallDate);

  return (
    <>
      <FormControl>
        <Controller
          render={({ field }) => (
            <FormControlLabel
              control={
                <CheckboxField
                  {...field}
                  defaultChecked={!!fallDate}
                  classes={{
                    root: styles.checkbox,
                    checked: styles.checked,
                  }}
                />
              }
              label="This patient fell in the last 6 months"
              className={styles.checkboxLabel}
            />
          )}
          name="fall"
          defaultValue={!!fallDate}
          control={control}
        />
      </FormControl>
      {watchFall ? (
        <FormControl className={styles.inputWrapper}>
          <Controller
            render={({ field }) => (
              <CustomDatePicker
                label="Fall date"
                {...register('fallDate', {
                  setValueAs: (value) => (isEmpty(value) ? null : value),
                })}
                maxDate={getDate()}
                onChange={(date) => {
                  field.onChange(date?.format(dateTimeFormat.SERVER_DATE_FORMAT));
                }}
                labelClassName={styles.inTakeLabel}
                validationErrorKey={dateValidationError.maxDate}
              />
            )}
            name={'fallDate'}
            control={control}
          />
        </FormControl>
      ) : null}
    </>
  );
};
export default FallBlock;
